import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Alert, AlertTitle, IconButton, Tooltip } from 'components/mui';
import { CloseOutlinedIcon } from '../icons';
import styles from './ErrorMsg.module.css';

const ErrorMsg = ({ state }) => {
	const [alert, setAlert] = useState(state);

	const resetAlert = () => {
		window.location.reload(false);
	};

	useEffect(() => {
		const splited = state.stack.split('\n');
		setAlert((prev) => ({ ...prev, stack: splited[1] }));

		// const interval = setInterval(() => {
		// 	setAlert({});
		// }, 4000);
		// return () => clearInterval(interval);
	}, [state]);

	return (
		<Dialog
			className={styles.dialog}
			open={alert.hasError}
			BackdropProps={{ style: { backgroundColor: 'transparent' } }}>
			<Alert
				className={styles.alert}
				severity="error"
				variant="filled"
				action={
					<Tooltip title="Close">
						<IconButton onClick={resetAlert}>
							<CloseOutlinedIcon fontSize="small" className={styles.icon} />
						</IconButton>
					</Tooltip>
				}>
				<AlertTitle>
					<strong>Error</strong>
				</AlertTitle>
				<div>Message : {alert.message}</div>
				<br />
				<div>Stack : {alert.stack}</div>
			</Alert>
		</Dialog>
	);
};

ErrorMsg.propTypes = {
	state: PropTypes.objectOf(
		PropTypes.shape({
			hasError: PropTypes.bool,
			message: PropTypes.string,
			stack: PropTypes.string,
		}),
	),
};

export default ErrorMsg;
